// Import each file, so Webpack can setup dynamic loading
import accordion from './accordion';
import add_more from './add_more';
import alumni_directory from './alumni-directory';
import av_placeholder from './av-placeholder';
import campus_directory from './campus_directory';
import campus_calendar from './campus-calendar';
import countdown from './countdown-timer';
import countup from './countup';
import course_description from './course-description';
import copy_link_to_clipboard from './copy-link-to-clipboard';
import date_picker from './date_picker';
import events from './events_item';
import fitVids from './fitVids';
import facstaff from './facstaff';
import faculty_staff from './faculty_staff';
import form_conditionals from './form_conditionals';
import gallery from './gallery';
import handbook from './handbook';
import home_page_banner from './home-page-banner';
import home_page_banner_mini from './home-page-banner-mini';
import home_page_analytics from './home-page-analytics';
import horizontal_nav from './horizontal-navigation';
import horizontal_dropdown_nav from './horizontal-dropdown-navigation';
import image_afterloader from './image-afterloader';
import lazy_load_images from './lazy-load-images';
import lightbox from './lightbox';
import lightbox_inline from './lightbox_inline';
import logout from './logout-page_post';
import comments from './comments';
import name_recording from './name_recording';
import navSwap from './nav_swap';
import overlay from './overlay';
import publication from './publication';
import randomize from './randomize';
import scroll_progress from './scroll_progress';
import search_form from './search_form';
import site_search from './site_search';
import searchSuggestions from './searchSuggestions';
import searchGuidedLinks from './searchCarletonGuidedLinks';
import searchAdvanceHighEdInstitutions from './searchAdvanceHighEdInstitutions';
import slider from './slider';
import sticky_blocks from './sticky-blocks';
import tab_panel from './tab_panel';
import stat from './stat';
import news_site_subnav from './news-site-subnav';
import datalist from "./datalist";


// Expose jQuery to the global object
if (undefined === jQuery) {
	var jQuery = require("jquery");
}
window.jQuery = window.$ = jQuery;

$(document).ready(($) => {
	console.log('DOM ready');

	// Get the base path for JS in the current environment
	let jsBasePath = null;
	const re = /js\/dist\/main(\.min)?\.js.*/i;
	$.each(document.getElementsByTagName('script'), (index, value) => {
		// console.log(index, value);
		if (value.src.match(re)) {
			jsBasePath = value.src.replace(/dist\/main(\.min)?\.js.*/i, '');
			return false;
		}
	});

	const loadFitVids = () => {
		const fitVidsSelectors = [
			'iframe[src*="player.vimeo.com"]',
			'iframe[src*="www.youtube.com"]',
			'iframe[src*="www.youtube-nocookie.com"]',
			'iframe[src*="www.kickstarter.com"]',
			'iframe[src*="carleton.hosted.panopto.com"]',
			'iframe[class*="media_work_iframe"]',
			'iframe.video[class*="media_file_iframe"]',
			'object',
			'embed',
		];
		$.each(fitVidsSelectors, (index, selector) => {
			if ($(selector).length) {
				fitVids(jsBasePath);
				console.log('fitVids loaded');
				return false;
			}
		});
	};
	loadFitVids();

	if ($('.accordion').length) {
		accordion();
		console.log('accordion loaded');
	}

	if ($('.av-placeholder').length) {
		av_placeholder(loadFitVids);
		console.log('av placeholder loaded');
	}

	if ($('#calendar').length) {
		events();
		console.log('events loaded');
	}

	if ($('.campus-directory').length) {
		campus_directory();
		console.log('campus directory loaded');
	}

	if ($('.scheduledContent__countdown').length) {
		countdown();
		console.log('countdown-timer loaded');
	}

	if ($('.countup').length) {
		countup();
		console.log('countup loaded');
	}

	if ($('.openCourseDescriptionModal').length) {
		course_description(jsBasePath);
		console.log('course_description loaded');
	}

	if ($('.facStaffBlock').length) {
		facstaff();
		console.log('facstaff loaded');
	}

	if ($('.faculty-staff--block').length) {
		faculty_staff();
		console.log('faculty-staff loaded');
	}

	if ($('duet-date-picker').length) {
		date_picker();
		console.log('date-picker element loaded');
	}

	if ($('.form-element[data-display-conditions]').length) {
		form_conditionals();
		console.log('form conditionals loaded');
	}

	if ($("a[id$='_add_more_button']").length) {
		add_more();
		console.log('add more loaded');
	}

	if ($('#campus-calendar-outer-wrapper').length) {
		campus_calendar();
		console.log('campus calendar page loaded');
	}

	if ($('.campus-handbook-page').length) {
		handbook();
		console.log('handbook page loaded');
	}

	if ($('.home-page-banner').length || $('.home-page-banner-mini').length) {
		home_page_analytics();
		console.log('home page analytics loaded');
	}

	if ($('.home-page-banner').length) {
		home_page_banner();
		console.log('home page banner loaded');
	}

	if ($('.home-page-banner-mini').length) {
		home_page_banner_mini();
		console.log('home page banner mini loaded');
	}

	if ($('.imgAfterload').length) {
		image_afterloader();
		console.log('image afterloading loaded');
	}

	if ($('.imageGallery').length) {
		gallery();
		console.log('gallery loaded');
	}

	if ($('.issueMenu').length) {
		publication();
		console.log('publications loaded');
	}

	if ($('img[data-src], img[data-srcset]').length) {
		lazy_load_images();
		console.log('lazy load images loaded');
	}

	if ($('.lightbox').length) {
		lightbox(jsBasePath);
		console.log('lightbox loaded');
	}

	if ($('.lightbox_inline').length) {
		lightbox_inline(jsBasePath);
		console.log('lightbox_inline loaded');
	}

	if ($('.logout-page_post').length) {
		logout();
		console.log('page/post logout loaded');
	}

	if ($('.main-carousel').length) {
		slider(jsBasePath);
		console.log('slider loaded');
	}

	if ($('.name-recording').length) {
		name_recording();
		console.log('name recording loaded');
	}

	if ($('.overlay').length) {
		overlay();
		console.log('overlay loaded');
	}

	if ($('#minisiteNavigation').length || $('#navigation').length) {
		navSwap();
		console.log('navSwap loaded');
	}

	if ($('.randomize').length) {
		randomize();
		console.log('randomize loaded');
	}

	if ($('.scroll_progress_indicator').length) {
		scroll_progress();
		console.log('scroll progress indicator loaded');
	}

	if ($('.search-form').length) {
		search_form();
		console.log('search form loaded');
	}

	if ($('.carleton-site-search').length) {
		site_search();
		console.log('site search block/page loaded');
	}

	if ($('.comments').length) {
		comments();
		console.log('comments loaded');
	}

	if ($('.block--sticky').length) {
		sticky_blocks();
		console.log('sticky blocks loaded');
	}

	if ($('.carleton-guided-links__field').length) {
		searchGuidedLinks(jsBasePath);
		console.log('search guided links loaded');
	}

	if ($('.carleton-advance--high-ed-lookup').length) {
		searchAdvanceHighEdInstitutions(jsBasePath);
		console.log('higher-ed institution lookup loaded');
	}

	// if ($('.input--suggest').length) {
	// 	searchSuggestions(jsBasePath);
	// 	console.log('search suggestions loaded');
	// }

	if ($('.tab-panel').length) {
		tab_panel();
		console.log('tab panel loaded');
	}

	if ($('.stat__main--has-alongside').length) {
		stat();
		console.log('stat loaded');
	}

	if ($('.news-site-subnav').length) {
		news_site_subnav();
		console.log('news site subnav loaded');
	}

	if ($('.horizontalNav').length) {
		horizontal_dropdown_nav();
		console.log('horizontal dropdown navigation loaded');
	}

	if ($('.site-subnav').length) {
		horizontal_nav();
		console.log('horizontal navigation loaded');
	}

	if ($('.alumni-directory').length) {
		alumni_directory(jsBasePath);
		console.log('alumni directory loaded');
	}

	if ($('.datalist').length) {
		datalist(jsBasePath);
		console.log('datalist loaded');
	}

	if ($('.copyLinkToClipboard').length) {
		copy_link_to_clipboard();
		console.log('clipboard link copier loaded');
	}

	if (navigator.userAgent.match(/firefox|fxios/i)) {
		window.onunload = function () {};
	}
});
